export const Component = {
    MFAModalOtpLabel: '本操作涉及敏感資訊，請輸入FinPass驗證碼：',
    RangePickerDays30: '近30天',
    RangePickerDays60: '近60天',
    RangePickerDays90: '近90天',
    RangePickerAll: '全部',
};
